import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {UserDefinedObjectTemplateAdditionalColumnType} from "@vesta/vos-types/modules/workspaceLevel/userDefinedObjects/domain/UserDefinedObjectTemplateAdditionalColumn";
import {z as zod} from "zod";

/** Section kinds for {@link OttopilotEventTemplate.eventPage.viewPanel}. */
export enum OttopilotEventViewPanelSectionKind {
    columnGroup = "a7e8f4c2-91d3-4f62-9e41-2c8b7f6e5d4a",
    eventOverview = "b8f9e5d3-a2c4-4173-af52-3d9e8f7c6b5a",
}

export type OttopilotEventTableViewColumn = {
    id: Uuid;
    field: string;
    displayName: string;
    sortingCapability: boolean;
    filteringCapability_contains: boolean;
} & (
    | {
          isAdditionalColumn: true;
          columnType: "OttopilotEvent";
          type: UserDefinedObjectTemplateAdditionalColumnType;
      }
    | {
          isAdditionalColumn: true;
          columnType: "OttopilotEventContainer";
          type: UserDefinedObjectTemplateAdditionalColumnType;
      }
    | {
          isAdditionalColumn: false;
          columnType: "OttopilotEvent" | "OttopilotEventContainer";
          type?: never;
      }
);

const eventTableViewColumnBaseValidator = zod.strictObject({
    id: uuidZodValidator,
    field: zod.string(),
    displayName: zod.string(),
    sortingCapability: zod.boolean(),
    filteringCapability_contains: zod.boolean(),
});

export const ottopilotEventTableViewColumnValidator: zod.ZodType<OttopilotEventTableViewColumn> = zod.union([
    eventTableViewColumnBaseValidator.extend({
        isAdditionalColumn: zod.literal(true),
        columnType: zod.literal("OttopilotEvent"),
        type: zod.enum(UserDefinedObjectTemplateAdditionalColumnType),
    }),
    eventTableViewColumnBaseValidator.extend({
        isAdditionalColumn: zod.literal(true),
        columnType: zod.literal("OttopilotEventContainer"),
        type: zod.enum(UserDefinedObjectTemplateAdditionalColumnType),
    }),
    eventTableViewColumnBaseValidator.extend({
        isAdditionalColumn: zod.literal(false),
        columnType: zod.enum(["OttopilotEvent", "OttopilotEventContainer"]),
    }),
]);
